import { ForBorrowerAge, SingleRateRowData, SingleRateRowData7174 } from "./age-bracket-and-benefit-amount.state"

export const remainingAgeRate1865 = [
    { id: 1, label: "", amount: 0, typeOfAge: 'under_min', value: false, isDefault: false, isShow: false },
    { id: 2, label: "", amount: 0, typeOfAge: 'main', value: true, isDefault: false, isShow: false },
    { id: 3, label: "", amount: 0, typeOfAge: 'under_max', value: false, isDefault: false, isShow: false },
]

export const profileAgeRate = {
    id: 2, label: "", amount: 0, value: true, isDefault: false
}

export const optionForBorrowerAge: ForBorrowerAge[] = [
    // { id: uuidv4(), label: "65-70", amount: null, value: null },
    // { id: uuidv4(), label: "71-75", amount: null, value: null },
    // { id: uuidv4(), label: "76-80", amount: null, value: null },
    { id: 6, label: "66-69", amount: null, value: false, isDefault: true, isShow: false },
    { id: 3, label: "66-70", amount: null, value: false, isDefault: true, isShow: true },
    { id: 4, label: "71-75", amount: null, value: false, isDefault: true, isShow: true },
    { id: 5, label: "76-80", amount: null, value: false, isDefault: true, isShow: true },
]

export const initialRowsFor6670: SingleRateRowData[] = [
    { termOfLoan: "6 months", gclip: 0, checked: false },
    { termOfLoan: "12 months", gclip: 0, checked: false },
    { termOfLoan: "18 months", gclip: 0, checked: false },
    { termOfLoan: "24 months", gclip: 0, checked: false },
];

export const initialRowsFor7175: SingleRateRowData[] = [
    { termOfLoan: "6 months", gclip: 0, checked: false },
    { termOfLoan: "12 months", gclip: 0, checked: false },
    { termOfLoan: "18 months", gclip: 0, checked: false },
    { termOfLoan: "24 months", gclip: 0, checked: false },
];

export const initialRowsFor7680: SingleRateRowData7174[] = [
    { attainedAge: "71", gclip12Months: 0 },
    { attainedAge: "72", gclip12Months: 0 },
    { attainedAge: "73", gclip12Months: 0 },
    { attainedAge: "74", gclip12Months: 0 },
];
